var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStartUsb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75.001,
    height: 75,
    viewBox: "0 0 75.001 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #a8a2f4;\n      }\n\n      .cls-3 {\n        opacity: 0.1;\n      }\n\n      .cls-4 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-5 {\n        fill: #040000;\n      }\n\n      .cls-6 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_2299",
    "data-name": "\\u77E9\\u5F62 2299",
    className: "cls-1",
    width: 21.822,
    height: 41.518
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_44854",
    "data-name": "\\u7EC4 44854",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35595",
    "data-name": "\\u8DEF\\u5F84 35595",
    className: "cls-2",
    d: "M159.374,44.044a37.5,37.5,0,1,1-37.5-37.5,37.5,37.5,0,0,1,37.5,37.5",
    transform: "translate(-84.373 -6.544)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_43232",
    "data-name": "\\u7EC4 43232",
    className: "cls-3",
    transform: "translate(26.59 21.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_43231",
    "data-name": "\\u7EC4 43231"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_43230",
    "data-name": "\\u7EC4 43230",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35599",
    "data-name": "\\u8DEF\\u5F84 35599",
    className: "cls-5",
    d: "M120.149,31.559a1.266,1.266,0,0,1-1.268-1.268v-4.8a1.122,1.122,0,0,0-1.121-1.12h-7.044a1.122,1.122,0,0,0-1.121,1.12v4.8a1.268,1.268,0,0,1-2.536,0v-4.8a3.661,3.661,0,0,1,3.658-3.656h7.044a3.661,3.661,0,0,1,3.657,3.656v4.8a1.266,1.266,0,0,1-1.268,1.268",
    transform: "translate(-103.327 -21.834)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35600",
    "data-name": "\\u8DEF\\u5F84 35600",
    className: "cls-5",
    d: "M122.671,52.478H107.384a3.271,3.271,0,0,1-3.268-3.267V33.35a3.271,3.271,0,0,1,3.268-3.267h15.287a3.27,3.27,0,0,1,3.267,3.267V49.211a3.27,3.27,0,0,1-3.267,3.267m-15.29-18.494-.055,14.535a.693.693,0,0,0,.69.695l13.958.053a.753.753,0,0,0,.755-.751V34.04a.692.692,0,0,0-.69-.692l-13.963-.053a.693.693,0,0,0-.695.69",
    transform: "translate(-104.116 -19.621)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35601",
    "data-name": "\\u8DEF\\u5F84 35601",
    className: "cls-5",
    d: "M111.586,30.6h0a1.273,1.273,0,0,1-1.273-1.273V25.893a1.273,1.273,0,1,1,2.547,0v3.433a1.273,1.273,0,0,1-1.273,1.273",
    transform: "translate(-102.454 -21.086)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35602",
    "data-name": "\\u8DEF\\u5F84 35602",
    className: "cls-5",
    d: "M114.468,30.6h0a1.273,1.273,0,0,1-1.273-1.273V25.893a1.273,1.273,0,1,1,2.547,0v3.433a1.273,1.273,0,0,1-1.273,1.273",
    transform: "translate(-101.681 -21.086)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35603",
    "data-name": "\\u8DEF\\u5F84 35603",
    className: "cls-5",
    d: "M113.069,56.552h0A1.649,1.649,0,0,1,111.42,54.9V47.185h3.3V54.9a1.649,1.649,0,0,1-1.649,1.649",
    transform: "translate(-102.157 -15.034)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35604",
    "data-name": "\\u8DEF\\u5F84 35604",
    className: "cls-5",
    d: "M117.8,43.975h-7.873a1.662,1.662,0,1,1,0-3.324H117.8a1.662,1.662,0,1,1,0,3.324",
    transform: "translate(-103.005 -16.787)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35605",
    "data-name": "\\u8DEF\\u5F84 35605",
    className: "cls-6",
    d: "M120.149,30.993a1.267,1.267,0,0,1-1.268-1.268v-4.8a1.122,1.122,0,0,0-1.121-1.12h-7.044a1.122,1.122,0,0,0-1.121,1.12v4.8a1.268,1.268,0,1,1-2.536,0v-4.8a3.661,3.661,0,0,1,3.658-3.656h7.044a3.661,3.661,0,0,1,3.657,3.656v4.8a1.267,1.267,0,0,1-1.268,1.268",
    transform: "translate(-76.737 -1.663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35606",
    "data-name": "\\u8DEF\\u5F84 35606",
    className: "cls-6",
    d: "M122.671,51.911H107.384a3.271,3.271,0,0,1-3.268-3.267V32.783a3.271,3.271,0,0,1,3.268-3.267h15.287a3.27,3.27,0,0,1,3.267,3.267V48.644a3.27,3.27,0,0,1-3.267,3.267m-15.29-18.494-.055,14.535a.693.693,0,0,0,.69.695l13.958.053a.753.753,0,0,0,.755-.751V33.473a.692.692,0,0,0-.69-.692l-13.963-.053a.693.693,0,0,0-.695.69",
    transform: "translate(-77.526 1.443)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35607",
    "data-name": "\\u8DEF\\u5F84 35607",
    className: "cls-6",
    d: "M111.586,30.033h0a1.274,1.274,0,0,1-1.273-1.273V25.326a1.273,1.273,0,1,1,2.547,0v3.433a1.274,1.274,0,0,1-1.273,1.273",
    transform: "translate(-75.944 -0.803)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35608",
    "data-name": "\\u8DEF\\u5F84 35608",
    className: "cls-6",
    d: "M114.468,30.033h0a1.274,1.274,0,0,1-1.273-1.273V25.326a1.273,1.273,0,0,1,2.547,0v3.433a1.274,1.274,0,0,1-1.273,1.273",
    transform: "translate(-75.007 -0.803)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35609",
    "data-name": "\\u8DEF\\u5F84 35609",
    className: "cls-6",
    d: "M113.069,55.985h0a1.649,1.649,0,0,1-1.649-1.649V46.618h3.3v7.718a1.649,1.649,0,0,1-1.649,1.649",
    transform: "translate(-75.567 6.726)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35610",
    "data-name": "\\u8DEF\\u5F84 35610",
    className: "cls-6",
    d: "M117.8,43.408h-7.873a1.662,1.662,0,1,1,0-3.324H117.8a1.662,1.662,0,1,1,0,3.324",
    transform: "translate(-76.418 4.376)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartUsb);
export default __webpack_public_path__ + "static/media/start_usb.0ea1cbdb27fb6709151f1d0d2b18a413.svg";
export { ForwardRef as ReactComponent };